'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ManageFocus = require('./components/ManageFocus.component');

var _ManageFocus2 = _interopRequireDefault(_ManageFocus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ManageFocus2.default; /*
                                          * Exports
                                          */


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-accessibility-manage-focus/lib/index.js
// module id = 679
// module chunks = 0 1